/**
 * @file: This file holds the order of a list of media labels.
 *
 * The kind labels come first, then the day and the scene labels, and each group
 * is sorted by name. The kind is what the operator comes to Compose for.
 *
 * The chips of Compose and the right-click menu of a row read this one order,
 * so a label stands in the same place in both. The library lists its labels by
 * name alone, and this file says nothing about that.
 */

import { kindLabelTest } from '../../shared/playlist-spread'
import { compareNames } from './name-order'

const byName = (a, b) => compareNames(a.name, b.name)

/**
 * The labels in the order the two lists of Compose show them.
 *
 * @param {Array} labels - The labels to order
 * @param {Array} sceneNames - The names that are scenes and thus no kind
 * @returns {Array} A new list, kinds first and each group by name
 */
function orderLabels (labels, sceneNames) {
  const isKind = kindLabelTest({ sceneNames })
  const groups = (labels || []).reduce((found, label) => {
    found[isKind(label) ? 'kinds' : 'rest'].push(label)
    return found
  }, { kinds: [], rest: [] })

  return [...groups.kinds.sort(byName), ...groups.rest.sort(byName)]
}

export { orderLabels }
